<template>
  <main-sidebar :name="name" :title="$t('filters')">
    <div class="p-4">
      <vs-row vs-w="12" class="mb-2">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-checkbox v-model="filters.requested">{{
            $t('requested')
          }}</vs-checkbox>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-2">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-checkbox v-model="filters.paid">{{ $t('paid') }}</vs-checkbox>
        </vs-col>
      </vs-row>
      <!-- Company -->
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('company') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.company"
            multiple
            :options="companies"
            class="w-full"
            :reduce="item => item.id"
            label="name"
            @input="filters.client = []"
          />
        </vs-col>
      </vs-row>
      <!-- Client -->
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('client') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.client"
            multiple
            :options="clientList"
            class="w-full"
            :reduce="client => client.ClientId"
            label="ClientName"
          />
        </vs-col>
      </vs-row>
      <!-- Period Inputs -->
      <vs-row vs-justify="center" class="my-4">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-input
            name="year"
            icon-pack="feather"
            icon="icon-calendar"
            v-model="filters.period_year"
            v-mask="'####'"
            v-validate="{min_value: 2000, max_value: 9999 }"
            :placeholder="$t('year')"
            icon-no-border
            autocomplete="off"
            class="w-full pr-2"
          />
        </vs-col>
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-input
            icon-pack="feather"
            icon="icon-hash"
            v-model="filters.period_month"
            v-mask="'##'"
            :placeholder="$t('month')"
            icon-no-border
            class="w-full pl-2"
            @input="checkMonth"
          />
        </vs-col>
        <vs-col vs-w="12">
          <span class="text-danger text-sm" v-show="errors.has('year')"
            >{{ errors.first('year') }}
          </span>
        </vs-col>
      </vs-row>
    </div>

    <div class="mx-4" slot="footer">
      <vs-button color="success" type="border" class="mr-6" @click="setFilter">
        {{ $t('apply_filters') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="clear">
        {{ $t('clear_filters') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import InputDate from '@/components/custom/InputDate'
import vSelect from 'vue-select'

export default {
  components: {
    MainSidebar,
    vSelect,
    InputDate
  },
  props: {
    clients: {
      type: Array,
      default: () => []
    },
    companies: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => ({
        requested: false,
        paid: false,
        client: () => []
      })
    }
  },
  computed: {
    isSidebarActive () {
      return this.$store.state.sidebar === this.name
    },
    clientList () {
      {
        if (this.filters.company.length === 0) {
          return this.clients
        }
        return this.clients.filter(client => this.filters.company.includes(client.CompanyId))
        
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (val) {
        this.init()
      }
    }
  },
  data () {
    return {
      name: 'tax-filter',
      loading: {
        submit: false
      },
      filters: {
        requested: false,
        paid: false,
        client: [],
        company: [],
        period_year: '',
        period_month: ''
      }
    }
  },
  methods: {
    init () {
      this.filters = Object.assign({},this.value )
    },
    clear () {
      this.filters = {
        requested: true,
        paid: true,
        client: [],
        company: [],
        period_year: '',
        period_month: ''
      }
      this.close()
      this.$emit('clear')
    },
    setFilter () {
      this.$emit('input', this.filters)
      this.close()
    },
    close () {
      this.$store.dispatch('toggleSidebar', '')
    },
    checkMonth() {
      if (this.filters.period_month > 12) {
        this.filters.period_month = 12
      }
    }
  }
}
</script>

<style>
.vs__dropdown-menu {
  max-height: 100px;
}
</style>
